import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { InovaCommonGraphqlApi } from 'inova-front-core/helpers/services/http';


@Injectable({
  providedIn: 'root'
})
export class ServiceGuard implements CanActivate {

  constructor(private inovaCommonGraphqlApi: InovaCommonGraphqlApi) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      return this.inovaCommonGraphqlApi.getClientServices().pipe(map(result=>{
        return result.some((x:any) => x[route.data.serviceRequired] === true);
      }))
  }

}
